export const GET_SALES_ORDER = "GET_SALES_ORDER";
export const GET_SALE_ORDER = "GET_SALE_ORDER";
export const ADD_SALE_ORDER = "ADD_SALE_ORDER";
export const DELETE_SALE_ORDER = "DELETE_SALE_ORDER";
export const UPDATE_SALE_ORDER = "UPDATE_SALE_ORDER";
